import Component from '@glimmer/component'
import type { ActivityBlock } from 'teacher-ui-client/subscription-type/writing-ideas/previews/route'
import ActivityTags from 'teacher-ui-client/components/writing-legends/activity-blocks/activity-tags.gts'

interface Signature {
  Element: HTMLDivElement
  Args: {
    data: ActivityBlock
    tags?: string
  }
}

function getWLImageFullPath(relativePath: string): string {
  return new URL(relativePath, 'https://cdn-editor.writinglegends.com/').href
}

export class ImageBlock extends Component<Signature> {
  get content() {
    const blockContent = this.args.data?.content
    if (blockContent) {
      // Image block content has two possible formats (see student portal tryParseImageContent):
      //   - JSON (new): '{"src":"owc/...","alt":"..."}'
      //   - Legacy plain path string: 'owc/activities/...'
      let path: string | undefined
      let alt = ''
      try {
        const imageContent = JSON.parse(blockContent) as { src?: string; url?: string; alt?: string }
        path = imageContent.src ?? imageContent.url
        alt = imageContent.alt ?? ''
      } catch {
        // Legacy format — content is a bare relative path, not JSON
        path = blockContent
      }
      if (!path) return null
      return {
        src: getWLImageFullPath(path),
        alt,
      }
    }
    return null
  }

  <template>
    <div class="relative border-2 border-[#B0EDF5]" ...attributes data-test-image-block>
      <ActivityTags class="absolute -top-4 right-2 flex space-x-3 select-none" @tags={{@tags}} />
      <img src={{this.content.src}} alt={{this.content.alt}} class="h-auto w-full" />
    </div>
  </template>
}

export default ImageBlock
